<!-- HxTwoColumnLayout Template

Component provides two-column flexbox layout with configurable gap spacing.
Uses content projection with directive selectors for left/right columns.

Each column takes up 50% width on desktop, stacks to 100% on mobile (≤768px).
Columns flex vertically and apply the same gap between items as between columns.
Columns are top-aligned, allowing different heights.
Empty columns preserve their space for layout consistency.

ARIA labels are optional - applied only when provided via inputs.
-->

<div class="hx-two-column-layout-left">
  <ng-content select="[hxTwoColumnLeft]"></ng-content>
</div>

<div class="hx-two-column-layout-right">
  <ng-content select="[hxTwoColumnRight]"></ng-content>
</div>
